import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { AuthProvider } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
import { ChatSocketProvider } from './context/ChatSocketContext';
import { ChatUIProvider } from './context/ChatUIContext';
import { StaffSocketProvider } from './context/StaffSocketContext';
import { SupportBubble } from './components/feature/SupportBubble';
import { GlobalChatListener } from './components/chat/GlobalChatListener';
import ChatOverlay from './components/chat/ChatOverlay';

function App() {
  return (
    <AuthProvider>
      <StaffSocketProvider>
        <NotificationProvider>
          <ChatSocketProvider>
            <ChatUIProvider>
              <BrowserRouter basename={__BASE_PATH__}>
                <GlobalChatListener />
                <ChatOverlay />
                <AppRoutes />
                <SupportBubble />
              </BrowserRouter>
            </ChatUIProvider>
          </ChatSocketProvider>
        </NotificationProvider>
      </StaffSocketProvider>
    </AuthProvider>
  );
}

export default App;
